<template>
  <pdfTemplate :data="data" ref="pdfTemplate" @close="handleClose" />
</template>
<script>
import viewMiXin from '@/utils/view-mixin.js';
import { purchaseApi } from '@/api';
import { STATUS_YES_TRUE } from '@/utils/constants';
import pdfTemplate from '@/views/center-business/purchase/order/components/pdfTemplate';

export default {
  name: 'BusinessPurchaseDetailCsg',
  components: { pdfTemplate },
  mixins: [viewMiXin],
  data() {
    return { STATUS_YES_TRUE, data: {} };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getData();
  },
  methods: {
    handleClose() {
      this.cancel();
    },
    getData() {
      purchaseApi['getCsgPurchaseOrderDetail']({
        id: this.$route.query.id,
      }).then(async res => {
        const skuList = res.purchaseOrderGoods.map(item => item.skuCode);
        purchaseApi.purchaseGoodsImport(skuList).then(res2 => {
          if (!res2?.length) return;
          const list = [];
          res2.forEach(v1 => {
            res.purchaseOrderGoods.forEach(v2 => {
              if (v2.skuCode === v1.skuCode) {
                list.push({...v2, ...v1, skuName: v1.skuName});
              }
            });
          });
          const seenCombinations = new Map();
          res.purchaseOrderGoods = list.filter(item => {
            const key = `${item.skuCode}-${item.batchCode}`; // 创建一个唯一的键
            if (!seenCombinations.has(key)) {
              seenCombinations.set(key, true);
              return true;
            }
            return false;
          });
        });
        this.data = res;
        this.$refs.pdfTemplate.cloneRemarks(res);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.flex-center {
  justify-content: left;
}
.numBox {
  position: relative;
  flex: 0 0 100px;
  padding-bottom: 15px;
}
.numBox::after {
  position: absolute;
  content: '';
  height: 5px;
  bottom: 0;
  left: 15px;
  right: 15px;
  display: block;
  // background-color: red;
}
.numBox:nth-child(1):after {
  background-color: $yellow;
}
.numBox:nth-child(2):after {
  background-color: $green;
}
.numBox:nth-child(3):after {
  background-color: $sub-dark;
}
.numBox:nth-child(4):after {
  background-color: $pink;
}
</style>
